import { useParams } from 'react-router-dom';

import DocumentsList from '@/app/document/List';
import { DOCUMENT_TYPE } from '@/app/document/enums';

import { useDocuments } from '@/data/document';

const FirstAid = () => {
  const params = useParams();

  const firstAidDocuments = useDocuments({
    coachId: params.id,
    type: DOCUMENT_TYPE.FIRST_AID
  });

  return (
    <>
      <h2 className="text-2xl font-bold mb-8">First Aid</h2>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <h4 className="text-md font-md text-muted-foreground mb-1">
            First Aid Documents
          </h4>
          <DocumentsList documents={firstAidDocuments.data} />
        </div>
      </div>
    </>
  );
};

export default FirstAid;
